import { TutorialFilterType } from '@/templates/Tutorial';

export interface translation {
  [lang: string]: string;
}

export interface abstractItem {
  fqdn: string;
  title: string;
  description: string;
}

export interface groupAttributes {
  optional?: boolean;
  deprecated?: string;
  since?: string;
  beta?: string;
  hidden?: string;
}

export interface itemAttributes {
  deprecated?: string;
  since?: string;
  beta?: string;
  hidden?: string;
  see?: string;
}

export type Roles =
  | 'Owner'
  | 'Accountant'
  | 'Developer'
  | 'Phone number manager'
  | 'Support'
  | 'SMS Manager'
  | 'Admin'
  | 'Supervisor'
  | 'Payer (disabled list of verifications)'
  | 'Payer'
  | 'User manager'
  | 'Call list manager'
  | 'User list write'
  | 'User list view'
  | 'ACD management'
  | 'Call history view'
  | 'Verification access'
  | 'Scenarios access';

// Method
export interface referencesMethod extends abstractItem {
  kind: 'method' | 'function' | 'prop' | 'constructor' | 'events';
  params?: ChildParams[];
  method?: string;
  filterType?: TutorialFilterType;
  returns: ChildParams[];
  uniqId?: string;
  roles: Roles[];
  annotations?: string[];
  attributes?: MethodAttributes;
  root_fqdn?: string;
  optional?: boolean;
  modifiers?: Record<string, any>;
}

export interface MethodAttributes extends itemAttributes, groupAttributes {
  throws?: string[];
  static?: boolean;
  abstract?: boolean;

  // В Attributes попадает много недокументированных свойств!
  [propName: string]: any;
}

export interface ChildParams {
  properties?: referencesFieldProps;
  attributes?: referencesFieldProps;
  description?: string;
  title: string;
  types: Array<string>;
  unnnamed?: boolean;
}

/**
 * Httpapi
 */
export interface referencesFolder {
  kind: 'ref_folder';
  fqdn: string;
  title: translationHTTP;
  children: (referencesAPIStruct | referencesAPIMethod | referencesErrors)[];
}

export interface referencesAPIStruct {
  kind: 'api_struct';
  fqdn: string;
  title: translationHTTP;
  description: translationHTTP;
  attributes: refGroupAttributes;
  children: referencesAPIField[];
}

export interface translationHTTP {
  curl?: string;
  php?: string;
  python?: string;
  golang?: string;
  nodejs?: string;
}

export interface refGroupAttributes {
  deprecated?: undefined | null | string;
  since?: undefined | null | string;
  beta?: undefined | null | string;
  hidden?: undefined | null | string;
  see?: undefined | null | string;
}

export interface referencesAPIField {
  kind: 'api_field';
  fqdn: string;
  title: translationHTTP;
  type: translationHTTP;
  description: translationHTTP;
  properties: referencesFieldProps;
}

export interface referencesProp {
  title: translationHTTP;
  type: translationHTTP;
  description: translationHTTP;
  properties: referencesFieldProps;
}

export interface referencesFieldProps {
  hidden?: undefined | null | string;
  named?: boolean;
  optional?: boolean;
  stream?: boolean;
  defaultValue?: translationHTTP;
}

export interface referencesErrors {
  kind: 'error_list';
  fqdn: string;
  title: string;
  description: string;
  children: referencesConst[];
}

export interface referencesConst {
  fqdn: string;
  title: translationHTTP;
  description: translationHTTP;
  kind: 'const';
}

export interface referencesAPIMethod {
  kind: 'api_method';
  fqdn: string;
  title: translationHTTP;
  description: translationHTTP;
  attributes: refGroupAttributes;
  requestData: referencesProp;
  responseData: referencesProp;
  examples: tutorialContentSourceBlock;
}

export interface tutorialContentSourceBlock {
  kind: 'content_source';
  env: 'http_api';
  title: string;
  description: string;
  examples: tutorialContentSourceExample[];
}

export interface tutorialContentSourceExample {
  name?: 'script' | 'return';
  lang: string;
  source: string;
  ghLink: string;
  highlight: string[];
}

/**
 * Tutorials
 */
export interface Tutorial extends abstractItem {
  kind: 'tutorial' | 'howto';
  filterType?: {
    isAudio: boolean;
    isVideo: boolean;
    isMessaging: boolean;
    isOmnichanell: boolean;
  };
  content: [TutorialContent];
  languages: any;
  tags: [{ [type: string]: string }];
}

export interface TutorialContent {
  title: string;
}

export enum BadgesType {
  OPTIONAL = 'optional',
  DEPRECATED = 'deprecated',
  STATIC = 'static',
  BETA = 'beta',
  HIDDEN = 'hidden',
  WARNING = 'warning',
  READONLY = 'readonly',
}

export const BadgeNames = {
  [BadgesType.OPTIONAL]: 'Optional',
  [BadgesType.DEPRECATED]: 'Deprecated',
  [BadgesType.STATIC]: 'Static',
  [BadgesType.BETA]: 'Beta',
  [BadgesType.HIDDEN]: 'Hidden',
  [BadgesType.WARNING]: 'Warning',
  [BadgesType.READONLY]: 'Read-only',
} as const;
